import styled from 'styled-components';

export const SubmitMeterHealthWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
